module.exports = __webpack_public_path__ + "dist/media/logo--pl.b4561e43.svg";